export default {
  state: {
    isMobile: false
  },
  mutations: {
    setMobileStatus(state, value) {
      state.isMobile = value
    }
  }
}